const template = `
	<h2 class="audi-headline-order-2 carstore-list__headline">{{=window.i18n['carstore-layer.saved-slots']}}</h2>
	<p class="audi-copy-m carstore-list__intro-text">{{=window.i18n['carstore-layer.manage-slots']}}</p>
	<div class="carstore-list__wrapper"></div>
`;
export {template as carstoreListHeadlineTemplate};
